import * as Yup from 'yup';

export const valoresInicialesLogin = {
	correo: '',
	contrasena: '',
};

export const esquemaDeValidacionLogin = Yup.object({
	correo: Yup.string().email('Email no válido').required('El email es obligatorio'),
	contrasena: Yup.string().required('La contraseña es obligatoria'),
});
